module.exports = __webpack_public_path__ + "img/homebg3.b8525849.png";